import { FC } from 'react';
import { useLoader } from 'thermia-react-container';

interface InlineLoaderProps {
  loader: ReturnType<typeof useLoader>['Loader'];
}

const InlineLoader: FC<InlineLoaderProps> = ({ loader: LoaderComponent }) => {
  return (
    <div style={{ display: 'inline-block', position: 'relative', width: '48px', height: '48px', marginTop: '-26px' }}>
      <LoaderComponent />
    </div>
  );
};

export default InlineLoader;
